export const IS_IOS = !!navigator.platform.match(/(iPhone|iPod|iPad)/i);
export const IS_APPLE = IS_IOS || !!navigator.platform.match(/(Mac)/i);

export const MOD_KEY: 'metaKey' | 'ctrlKey' = IS_APPLE ? 'metaKey' : 'ctrlKey';

export const isTouchDevice = window.matchMedia
  ? window.matchMedia('(pointer: coarse)').matches
  : false;
